import React from 'react';
import { NoticeModal, Text } from '@lili/lili-frontend-common';
import { ReactComponent as CheckIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-success-new.svg';
import { ReactComponent as OopsIcon } from '../../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';

export interface LimitSuccesModalTypeProps {
  title: string;
  content: string;
  buttonText: string;
  success: boolean;
}
export interface LimitsSuccessModalProps {
  onSubmit: () => void;
  modalType: LimitSuccesModalTypeProps;
}

export const LimitsSuccessModal = ({ onSubmit, modalType }: LimitsSuccessModalProps) => {
  const content = (
    <div className='flex flex-col justify-center items-center pb-[46px] '>
      <Text.H10 className='text-center'>{modalType.content}</Text.H10>
    </div>
  );

  return (
    <NoticeModal
      onClickOutside={onSubmit}
      buttonText={modalType.buttonText}
      title={modalType.title}
      id='success-modal'
      image={
        modalType.success ? (
          <CheckIcon className='w-12/12 stroke-action0 text-action03' />
        ) : (
          <OopsIcon className='w-12/12 stroke-action0' />
        )
      }
      content={content}
      onSubmit={onSubmit}
    />
  );
};
